// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3ad7f744","239":"e6bdc10e","455":"3b284b15"}[chunkId] + ".chunk.js";
};